import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { History, Maybe, ZoneStatus } from '@/__generated__/graphql';
import { ZoneStatusMapper } from '../common';
import { ZoneStatusList } from './ZoneStatusList';

type Props = {
  status: ZoneStatus;
  histories: Maybe<History>[];
};

export const ZoneStatusTimeline = ({ status, histories: maybeHistories }: Props) => {
  if (maybeHistories === null) return <></>;

  const histories = maybeHistories as History[];

  return (
    <Stack justifyContent="space-around" alignItems="center" direction="row" spacing={0}>
      <Stack direction="row" width="fit" justifyContent="center" alignItems="center">
        <ZoneStatusList status={status} histories={histories} />
      </Stack>
      <Typography fontWeight="bold">{ZoneStatusMapper[status]}</Typography>
    </Stack>
  );
};
